import { render, staticRenderFns } from "./WorkspaceMembers.vue?vue&type=template&id=5e60a496&scoped=true"
import script from "./WorkspaceMembers.vue?vue&type=script&lang=js"
export * from "./WorkspaceMembers.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceMembers.vue?vue&type=style&index=0&id=5e60a496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e60a496",
  null
  
)

export default component.exports